// IIFE so a re-executed script (theme editor re-render) can't redeclare top-level consts.
(() => {
const QUIZ_TAB_DISMISS_KEY = 'themex-quiz-tab-dismissed';
const QUIZ_INTENT_EVENTS = ['pointerover', 'focusin', 'touchstart'];

let quizModalLoad = null;

const loadQuizModal = (modal) => {
  if (customElements.get('quiz-modal')) return Promise.resolve();

  quizModalLoad ??= new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = modal.dataset.quizScriptUrl;
    script.async = false;
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', () => reject(new Error(`Could not load ${script.src}`)), { once: true });
    document.head.appendChild(script);
  }).then(() => customElements.whenDefined('quiz-modal'));

  return quizModalLoad;
};

const isQuizTabDismissed = () => {
  try {
    return sessionStorage.getItem(QUIZ_TAB_DISMISS_KEY) === '1';
  } catch {
    return false;
  }
};

// Safe to re-run: reads the current tab, so it also covers an editor-replaced one.
const showQuizTab = (isDesignMode) => {
  const tab = document.querySelector('[data-quiz-tab]');
  if (tab && (isDesignMode || !isQuizTabDismissed())) tab.hidden = false;
};

// Delegated so a replaced tab needs no rebinding.
const initQuizTabDismiss = () => {
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-quiz-tab-dismiss]')?.closest('[data-quiz-tab]');
    if (!tab) return;

    tab.hidden = true;
    try {
      sessionStorage.setItem(QUIZ_TAB_DISMISS_KEY, '1');
    } catch {
      // sessionStorage unavailable — hide for this page only.
    }
  });
};

const initDesignMode = (modal) => {
  loadQuizModal(modal).catch(() => {});

  // Re-query: the editor replaces the section element on every re-render.
  const toggleFromEditor = async (event, shouldOpen) => {
    const currentModal = document.querySelector('quiz-modal');
    if (!currentModal || !event.target.contains(currentModal)) return;
    await loadQuizModal(currentModal);
    if (shouldOpen) currentModal.open();
    else currentModal.close();
  };

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('quiz-modal')) showQuizTab(true);
  });
  document.addEventListener('shopify:section:select', (event) => toggleFromEditor(event, true));
  document.addEventListener('shopify:section:deselect', (event) => toggleFromEditor(event, false));
};

const initIntentPreload = (modal) => {
  const handleIntent = (event) => {
    if (!event.target.closest?.('[data-quiz-trigger]')) return;
    for (const type of QUIZ_INTENT_EVENTS) document.removeEventListener(type, handleIntent);
    loadQuizModal(modal).catch(() => {});
  };

  for (const type of QUIZ_INTENT_EVENTS) document.addEventListener(type, handleIntent, { passive: true });
};

// Opens the modal for clicks that land before quiz-modal.js has defined the element.
const initClickFallback = (modal) => {
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-quiz-trigger]');
    if (!trigger || customElements.get('quiz-modal')) return;

    event.preventDefault();
    const preselect = Number.parseInt(trigger.dataset.quizPreselect, 10);
    try {
      await loadQuizModal(modal);
      modal.open(preselect);
    } catch {
      // Script failed to load — leave the page as is.
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('quiz-modal');
  if (!modal) return;

  const isDesignMode = Boolean(window.Shopify?.designMode);
  showQuizTab(isDesignMode);
  initQuizTabDismiss();

  if (isDesignMode) {
    initDesignMode(modal);
    return;
  }

  initIntentPreload(modal);
  initClickFallback(modal);
});
})();
